export default __webpack_public_path__ + "static/media/bookmark.35a3b02b.svg";